import request from "@/utils/request";
// 优惠券页
export function Coupon(params) {
  return request({
    url: "/h5/Coupon/index",
    method: "post",
    params,
  });
}
// 领取可更新优惠券
export function receiveUpdateCoupon(params) {
  return request({
    url: "/h5/Coupon/receiveUpdateCoupon",
    method: "post",
    params,
  });
}
// 欢迎语跳转领券
export function receiveVisitorCoupon(params) {
  return request({
    url: "/h5/Coupon/receiveVisitorCoupon",
    method: "post",
    params,
  });
}
